import {postAction} from "@/eiuov-utils/axios/api";

const queryBookListAction = (params) => postAction("/book/queryBookList", params)

export {
    queryBookListAction,
}
